import { defineStore } from 'pinia'
import { useUserStore } from '@/stores/user.js'
import { post } from '@/common/request'
import { url } from '@/common/config'

export const useCashBackStore = defineStore('cashback', {
  state: () => {
    return {}
  },
  getters: {
    country() {
      return useUserStore().country
    }
  },
  actions: {
    load() {
      return post(url.cashback.load)
    },
    collect(configId, poolType) {
      return post(url.cashback.collect, { configId, poolType })
    },
    record(query) {
      return post(url.cashback.record, query)
    },
    marquee() {
      let timestamp = new Date().getTime()
      return post(url.cashback.marquee, { timestamp })
    }
  }
})
